var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Thin/Student"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Thin/\xF0\x9F\x92\x9C Icon/Thin/Vector",
    d: "M4 8V18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Thin/\xF0\x9F\x92\x9C Icon/Thin/Vector_2",
    d: "M6.77539 26.9999C7.77597 25.4653 9.14361 24.2045 10.7544 23.3317C12.3653 22.459 14.1683 22.002 16.0004 22.002C17.8324 22.002 19.6355 22.459 21.2464 23.3317C22.8572 24.2045 24.2248 25.4653 25.2254 26.9999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Thin/\xF0\x9F\x92\x9C Icon/Thin/Vector_3",
    d: "M28 8L16 12L4 8L16 4L28 8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Thin/\xF0\x9F\x92\x9C Icon/Thin/Vector_4",
    d: "M21.1625 10.2754C22.0798 11.2771 22.6859 12.5241 22.9068 13.8643C23.1277 15.2044 22.954 16.58 22.4067 17.8231C21.8595 19.0663 20.9624 20.1233 19.8248 20.8655C18.6872 21.6077 17.3583 22.0028 16 22.0028C14.6417 22.0028 13.3128 21.6077 12.1752 20.8655C11.0376 20.1233 10.1405 19.0663 9.59329 17.8231C9.04604 16.58 8.87229 15.2044 9.09322 13.8643C9.31414 12.5241 9.9202 11.2771 10.8375 10.2754",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.6741f96cfe212d678d350e1deedc165a.svg";
export { ForwardRef as ReactComponent };